import { Description as DescriptionIcon } from "@mui/icons-material";
import { Box, Button, Container, Stack, Typography } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";
import {
    SUBSCRIPTION_TERMS_OF_USE_LABEL,
    SUBSCRIPTION_TERMS_OF_USE_PDF_PATH,
} from "../config/legalDocuments";
import { Reveal, StaggerGroup } from "../theme/animation";

/** Links for trust/safety documents. Replace placeholder "#" with PDF URLs when available. */
const TRUST_LINKS = [
    {
        label: "Terms of Use",
        href: "https://docs.google.com/document/d/1sva34NW-8vZ_240H7Uet6MEQOGaHlDx5bKly_8HDp7g/export?format=pdf",
        external: true,
    },
    {
        label: "Evidence Based Framework",
        href: "https://storage.googleapis.com/strongmsp-media/media/trust/SMSP_Evidence_Based_Framework_Inclusive.pdf",
        external: true
    },
    {
        label: "Data & Privacy Summary",
        href: "https://docs.google.com/document/d/17CTiN6JkMbtZ5VzwSh0EdjG7uKmXKgCRTfuMuzRbZ74/export?format=pdf",
        external: true
    },
    {
        label: SUBSCRIPTION_TERMS_OF_USE_LABEL,
        href: SUBSCRIPTION_TERMS_OF_USE_PDF_PATH,
        external: true,
    },
    {
        label: "Features to Vision",
        href: "https://docs.google.com/document/d/1kEV7P428Dda8VsQBq9ZMHxGx-OWYvs45IgZR_B2XCRc/export?format=pdf",
        external: true
    }, {
        label: "Recording Policy",
        href: "https://storage.googleapis.com/strongmsp-media/media/trust/Recording_Review_Safety_Monitoring_Compliance_SOP.pdf",
        external: true
    },
    {
        label: "Mandated Reporting Policy",
        href: "https://storage.googleapis.com/strongmsp-media/media/trust/Mandated_Reporting_Safety_Escalation_Policy.pdf",
        external: true
    },
    {
        label: "Quality Assurance & System Integrity",
        href: "/qa",
        external: false
    },
    {
        label: "Download Your Data",
        href: "/account/download",
        external: false
    },
    {
        label: "Delete Account",
        href: "/account/delete",
        external: false
    }
] as const;

const Trust: React.FC = () => {
    return (
        <Container maxWidth="sm" sx={{ py: 6 }}>
            <Reveal variant="fadeUp">
                <Typography variant="h4" component="h1" sx={{ mb: 3, fontWeight: 600 }}>
                    Trust, Safety & Evidence
                </Typography>
            </Reveal>
            <Reveal variant="fadeUp" delay={0.08}>
                <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
                    Download or view our policies and frameworks.
                </Typography>
            </Reveal>
            <Stack spacing={2}>
                <StaggerGroup stagger={0.08}>
                    {TRUST_LINKS.map(({ label, href, external }, index) => (
                        <Reveal key={label} variant="fadeUp" staggerIndex={index}>
                            <Box>
                                {external ? (
                                    <Button
                                        component="a"
                                        href={href}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        variant="outlined"
                                        fullWidth
                                        startIcon={<DescriptionIcon />}
                                        sx={{ justifyContent: "flex-start", py: 1.5, textTransform: "none" }}
                                    >
                                        {label}
                                    </Button>
                                ) : (
                                    <Button
                                        component={Link}
                                        to={href}
                                        variant="outlined"
                                        fullWidth
                                        startIcon={<DescriptionIcon />}
                                        sx={{ justifyContent: "flex-start", py: 1.5, textTransform: "none" }}
                                    >
                                        {label}
                                    </Button>
                                )}
                            </Box>
                        </Reveal>
                    ))}
                </StaggerGroup>
            </Stack>
        </Container>
    );
};

export default Trust;
